// Utility function to check if Crazy Week is active
export const isCrazyWeekActive = () => {
  // CAMPANHA ENCERRADA - retorna false
  return false;
};

// Get countdown time left
export const getCrazyWeekTimeLeft = () => {
  const endDate = new Date('2026-05-04T23:59:59'); // Conta até esta data
  const now = new Date();
  const difference = endDate - now;

  if (difference > 0) {
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      total: difference
    };
  }

  return { days: 0, hours: 0, minutes: 0, seconds: 0, total: 0 };
};
